import React, { useRef, useEffect, useState } from 'react';
import styles from './RealEstateSection.module.scss';
import { motion } from 'framer-motion';

const features = [
  {
    title: "Investment Vehicle",
    description: "Simplified access to rental income, capital gain and digital currency."
  },
  {
    title: "Rent-To-Own",
    description: "Long-term, quality tenants, motivated through our unique property ownership pathway and rewarded through tokenisation."
  },
  {
    title: "Agents Marketplace",
    description: "Centralised platform for agents to demonstrate value though listing quality properties around the country."
  },
  {
    title: "Sellers Dream",
    description: "Sellers keep 100% of sale price, and remain engaged with the platform through tokenisation. All fees distributed to buyers."
  }
];

const RealEstateSection = () => {
  const ref = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      if (rect.top < window.innerHeight - 100) setVisible(true);
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.9, ease: "easeOut" }
    }
  };

  return (
    <section ref={ref} className={styles.section}>
      <div className={styles.card + ' ' + (visible ? styles.visible : '')}>
        <motion.h2 
          className={styles.title}
          initial={{ opacity: 0, y: -15 }}
          animate={visible ? { opacity: 1, y: 0 } : { opacity: 0, y: -15 }}
          transition={{ duration: 0.8 }}
        >
          Real Estate Reimagined
        </motion.h2>
        <motion.div 
          className={styles.featuresGrid}
          initial="hidden"
          animate={visible ? "visible" : "hidden"}
          variants={containerVariants}
        >
          {features.map((feature, index) => (
            <motion.div 
              key={index} 
              className={styles.featureItem}
              variants={itemVariants}
            >
              <h3 className={styles.featureTitle}>{feature.title}</h3>
              <p className={styles.featureDescription}>
                {feature.description.split('and').map((part, i, arr) => 
                  i === arr.length - 1 && arr.length > 1 
                    ? <><span className={styles.highlight}>and</span> {part}</> 
                    : part + (i < arr.length - 2 ? ' and ' : '')
                )}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default RealEstateSection; 